const FETCH_TEAM_INITIATED = 'FETCH_TEAM_INITIATED';
const FETCH_TEAM_SUCCEEDED = 'FETCH_TEAM_SUCCEEDED';
const FETCH_TEAM_FAILED = 'FETCH_TEAM_FAILED';

export default {
  FETCH_TEAM_INITIATED,
  FETCH_TEAM_SUCCEEDED,
  FETCH_TEAM_FAILED,
};
